var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 39C10.0515 39 3 31.8366 3 23C3 14.1634 10.0515 7 18.75 7C24.8036 7 30.0596 10.4695 32.6962 15.5579C32.9454 15.5416 33.1967 15.5333 33.45 15.5333C39.8289 15.5333 45 20.7865 45 27.2667C45 33.7468 39.8289 39 33.45 39C28.0918 39 24.257 39 18.75 39Z",
    stroke: "#01758C",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7189 31.4572V30.4004L34.7371 28.746C35.4907 28.1223 35.7853 27.7932 35.7853 27.2907C35.7853 26.7797 35.4474 26.5025 34.971 26.5025C34.5033 26.5025 34.1828 26.7624 33.7323 27.3167L32.7968 26.5631C33.3945 25.7489 33.9749 25.3071 35.0576 25.3071C36.3136 25.3071 37.1452 26.0434 37.1452 27.1955C37.1452 28.2089 36.6255 28.7113 35.5514 29.5429L34.5639 30.3052H37.2058V31.4572H32.7189Z",
    fill: "#01758C",
    stroke: "#01758C",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2951 30.1877C23.1912 30.1877 21.0256 27.8345 21.0256 24.9616C21.0256 22.1176 23.22 19.7355 26.324 19.7355C29.4279 19.7355 31.5934 22.0887 31.5934 24.9616C31.5934 27.8057 29.399 30.1877 26.2951 30.1877ZM26.324 28.5564C28.3307 28.5564 29.731 26.9539 29.731 24.9616C29.731 22.9982 28.3018 21.3668 26.2951 21.3668C24.2884 21.3668 22.888 22.9693 22.888 24.9616C22.888 26.925 24.3172 28.5564 26.324 28.5564Z",
    fill: "#01758C",
    stroke: "#01758C",
    strokeWidth: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9325 30.1877C12.9874 30.1877 10.793 27.8923 10.793 24.9616C10.793 22.0887 12.9441 19.7355 16.0047 19.7355C17.867 19.7355 18.9931 20.3851 19.9604 21.3091L18.8198 22.6228C18.0114 21.8721 17.1452 21.3668 15.9902 21.3668C14.0557 21.3668 12.6553 22.9549 12.6553 24.9616C12.6553 26.9395 14.0557 28.5564 15.9902 28.5564C17.2318 28.5564 18.0258 28.0511 18.892 27.2426L20.0325 28.3976C18.9787 29.4948 17.8237 30.1877 15.9325 30.1877Z",
    fill: "#01758C",
    stroke: "#01758C",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.5261481fbc7e7825cfec6ce14e061602.svg";
export { ForwardRef as ReactComponent };